import React   , {useEffect, useState } from "react";
import TaskInformation from "../TaskInformation";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { AiOutlineUser } from "react-icons/ai";
import { GrConfigure } from "react-icons/gr";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import ExpertSelector from './ExpertSelection'
import {IoCloseOutline} from "react-icons/io5";
import GarageSelection from "./GarageSelection";
import ValidationButton from "../ValidationButton";
import PreviewButton from "../PreviewButton";
import { useDispatch, useSelector } from "react-redux"; 
import ExpertCart from "./ExpertCart";
import GarageCart from "./GarageCart";
import {
    createInspectionMission
} from "../../../store/action/inspectionMission"
import { getOrganizationDetails } from '../../../store/action/party';
import { getClaimDetails , updateClaim } from "../../../store/action/claim";
import {
    createReparationMission,
    getServiceProposalById,
    updateServiceProposal
} from "../../../store/action/claimManagement"
import { getTask , completeTask } from "../../../store/action/taskAction";
import {createMissionExpert } from "../../../store/action/missionExpert"
import { useNavigate, useParams} from "react-router-dom";
import {traduireTypeDeMissionForTask } from "../../../utils/translateMissionType";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        position: 'relative',
    },
    paper: {
        display: "flex",
        borderRadius: "11px",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
    },
    leftSection: {
        flex: 1,
        marginTop:'10px',
        borderRadius:'8px',
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
    },
    AffectedSection: {
        flex: 1,
        display: "flex",
        alignItems: "center",
        flexDirection: 'column',
        justifyContent: "center"
    },
    uploadRectangle: {
        width: '100%',
        height: '374px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
        cursor: 'pointer',
        opacity: 0.8,
        backgroundColor: 'rgba(243, 246, 249, 1);'
    },
    uploadTextPrimary: {
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: '24px',
        color: 'rgba(60, 101, 86, 1)',
        marginTop: '10px',
    },
    uploadTextSecondary: {
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: '400',
        lineHeight: '23px',
        textAlign: 'center',
        color: 'rgba(128, 128, 143, 1)',
        marginTop: '5px',
    },
    //popup:
    titre: {
        fontFamily: 'Poppins',
        fontSize: 12,
        fontWeight: 600,
        color: 'rgba(63, 66, 84, 1)',
    },
    titreLabel: {
        fontFamily: 'Poppins',
        fontSize: 12,
        fontWeight: 400,
        color: 'rgba(32, 18, 70, 1)',
    },
    tablePagination: {
        fontFamily: 'Poppins',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '18px',
        color: 'rgba(32, 18, 70, 1)'
    },
    dateRangeContainer: {
        display: 'flex',
        alignItems: 'center',
        border: '0.61px solid rgba(226, 217, 239, 1)',
        background: 'rgba(255, 255, 255, 1)',
        borderRadius: 5,
        padding: '5px 10px',
    },
    dateContainer: {
        border: 'none',
        outline: 'none',
        background: 'rgba(255, 255, 255, 1)',
        borderRadius: 5,
        fontFamily: 'Poppins',
        paddingLeft: '5px',
    },
    inputContainer: {
        border: '0.61px solid rgba(226, 217, 239, 1)',
        background: 'rgba(255, 255, 255, 1)',
        width: '148px',
        height: '34px',
        borderRadius: 5,
        marginLeft: '20px',
    },
    dialogPaper: {
        width: '1300px',
        overflow: 'hidden',
        background: 'rgb(243, 246, 249)',
    },
    dialogTitle: {
        fontFamily: "Poppins",
        fontWeight: 500,
        fontSize: 18,
        color: 'rgba(63, 66, 84, 1)',
        backgroundColor: 'white',
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
    },

    dialogContent: {
        overflowY: 'auto',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
    },
    closeButton: {
        cursor: 'pointer',
        color: 'rgba(32, 18, 70, 1)',
        marginLeft: 1051,
    },
    //for the preview btn
    previewBtn:{
        position: 'absolute',
        //background: 'rgb(243, 246, 249)',
        right: '-165px',
    },
    mainContent: {
        width: '95%',
        display: 'flex',
        flexDirection: 'column',
    }
}));

const DesignateParties = () => {
    const { taskId } = useParams();
    const navigate = useNavigate();

    const classes = useStyles();
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [dialogContent, setDialogContent] = useState("");
    const [isTaskClaimed, setIsTaskClaimed] = useState(true);
    const username = localStorage.getItem('username');
    const taskReducer = useSelector((state) => state.taskReducer?.taskList?.find(task => task?.taskId === taskId));
    const [task, setTask] = useState(taskReducer);
    const [showSections , setShowSections]= useState([false, false]);
    const [designatedExpert , setDesignatedExpert] = useState("");
    const [designatedGarage , setDesignatedGarage] = useState("");
    const [infoSinistre, setInfoSinistre] = useState(task?.businessKey)
    const [variables, setVariables] = useState(task?.variables)
    const [inspectorFilters, setInspectorFilters] = useState([]);
    const [expertFilters, setExpertFilters] = useState([]);
    const [repairerFilters, setRepairerFilters] = useState([]);
    const designatedRepairerPartyUid = task?.variables?.designatedRepairerPartyUid?.value || null;
    const serviceProposalId = task?.variables?._proposedServiceId?.value
    //console.log("_proposedServiceId", serviceProposalId)

    const serviceProposal = async () => {
        try {
            let proposal = null;
            let repairerFilters = []; 
            let expertFiltersArray = [];
    
            if (serviceProposalId) {
                proposal = await getServiceProposalById(serviceProposalId);
                if (proposal?.gouvernorat) {
                    repairerFilters.push({ key: 'GOUVERNORAT', value: proposal.gouvernorat });
                    expertFiltersArray.push({ key: 'GOUVERNORAT', value: proposal.gouvernorat });
                }
            }
    
            if (task?.variables?.managementType?.value) {
                repairerFilters.push({ key: 'SCOPE', value: task.variables.managementType.value });
                expertFiltersArray.push({ key: 'SCOPE', value: task.variables.managementType.value });
            }
    
            if (task?.variables?.missionType?.value) {
                expertFiltersArray.push({ key: 'MISSIONTYPE', value: traduireTypeDeMissionForTask (task.variables.missionType.value) });
            }
    
            if (task?.variables?.managementType?.value === 'CLASSIQUE' && proposal?.gouvernorat) {
                expertFiltersArray.unshift({ key: 'GOUVERNORAT', value: proposal.gouvernorat });
            }
    
            setRepairerFilters(repairerFilters);
            setExpertFilters(expertFiltersArray);
        } catch (error) {
            console.error(`Error fetching service proposal: ${error.message}`);
        }
    };
    

    

    // useEffect(() => {
    //     console.log("Updated inspectorFilters:", inspectorFilters);
    // }, [inspectorFilters]);

    // useEffect(() => {
    //     const fetchTask = async () => {
    //         try {
    //             const response = await getTask(taskId, username);
    //             setTask(response)
    //             setInfoSinistre(response?.businessKey)
    //             setVariables(response?.variables)
    //         } catch (error) {
    //             console.error(`Error fetching task details: ${error.message}`);
    //         }
    //     };
    //     fetchTask();
    // }, [dispatch, taskId, username]);


    const sections = [
        {
          icon: <AiOutlineUser style={{ color: "rgba(60, 101, 86, 1)" }} size={40} />,
          textPrimary: "Désignation expert",
          textSecondary: "Sélectionner un expert de notre base de données",
          
          onClick: () => handleUploadClick("Désignation expert")
        },
        {
          icon: <GrConfigure style={{ color: "rgba(60, 101, 86, 1)" }} size={40} />,
          textPrimary: "Désignation garage",
          textSecondary: "Sélectionner un garage de notre base de données",
          onClick: () => handleUploadClick("Désignation garage")
        }
      ];

    const designatedExperts = (expert) => {
        setDesignatedExpert(expert);
        // console.log("designated expert", designatedExpert)
        handleClose();
    };

   

    const designatedGarages = async (garage) => {
        setDesignatedGarage(garage);
        handleClose();
        
    };
    const fetchTask = async () => {
        try {
            const response = await getTask(taskId, username);
            setTask(response);
                setInfoSinistre(response?.businessKey)
                setVariables(response?.variables)
              setShowSections([response?.variables?._designateExpert?.value , response?.variables?._designatedGarage?.value])
            if(response.assignee === username){
                setIsTaskClaimed(false)
            }else {
                 setIsTaskClaimed(true)
            }

        } catch (error) {
            console.error(`Error fetching task details: ${error.message}`);
        }
    };
    
    // const fetchInspectorByAssociatedParty = async (associatedParty) => {
    //     try {
    //         const inspectors = await dispatch(fetchInspectorsByAssociatedParty(associatedParty));
    //         const inspector = inspectors[0];
    //         console.log("Inspector:", inspector);
    //         return inspector;
    //     } catch (error) {
    //         console.error("Error fetching inspector:", error);
    //     }
    // };
    const handleUploadClick = (content) => {
        setDialogContent(content);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setInspectorFilters([])
    };

    function getFirstActiveEmailContact(data) {
        const channels = data.personDetails.partyCommunicationChannels;
        const activeEmail = channels.find(
          (channel) =>
            channel.status === "ACTIVE" &&
            channel.communicationChannel.type === "EMAILCONTACT"
        );
        return activeEmail ? activeEmail.communicationChannel.value : "N/A";
      }

    function getFirstActivePhoneContact(data) {
        console.log("data", data)
        const channels = data.organization.partyCommunicationChannels;
        const activePhone = channels.find(
            (channel) =>
            channel.status === "ACTIVE" &&
            channel.communicationChannel.type === "PHONECONTACT"
        );
        return activePhone ? activePhone.communicationChannel.value : "N/A";
    }

    function getFirstActivePhoneContactForInspector(data) {
        console.log("data", data)
        const channels = data.personDetails.partyCommunicationChannels;
        const activePhone = channels.find(
            (channel) =>
            channel.status === "ACTIVE" &&
            channel.communicationChannel.type === "PHONECONTACT"
        );
        return activePhone ? activePhone.communicationChannel.value : "N/A";
    }

    async function getEmailContactGarage(associatedParty) {
        const partyRepairer =  await getOrganizationDetails(associatedParty);
    const channels = partyRepairer.partyCommunicationChannels;
    const activeEmail = channels.find(
        (channel) =>
        channel.status === "ACTIVE" &&
        channel.communicationChannel.type === "EMAILCONTACT"
    );
    return activeEmail ? activeEmail.communicationChannel.value : "N/A";
    }

    const ValidationAction = async () => {
        let variables = {};
  
        if (showSections[0]) {
          if (!designatedExpert) {
            alert("Veuillez sélectionner Expert.");
            return;
          }
          let location = designatedGarage? designatedGarage.organizationName :"" ;
          if (task?.variables?.managementType?.value === 'RGA') {
                location = task?.variables?.designatedRepairer?.value;
            }
          const InspectionMission = {
            currentCarValue: 0,
            initialCarValue: 0,
            missionType: task.variables?.missionType?.value || "FIRST_INSPECTION",
            assignedExpert: designatedExpert.associatedParty,
            location:  location,
            relatedClaimUid: task.businessKey || "unknown",
            status: "OPEN"
          };
          try {
            //create Mission in app Expert
           const response = await dispatch(createInspectionMission(InspectionMission));
              console.log(response)
            setVariables(variables.inspectionMissionId = { value: response._id, type: "String" });

            const claim = await dispatch(getClaimDetails(task?.businessKey));
            let additionalData = claim.additionalData;

            // Vérifiez que `inspectionMissions` existe, sinon, initialisez-le
            additionalData.inspectionMissions = additionalData.inspectionMissions || {};

            // Ajoutez/modifiez la propriété dynamiquement
            additionalData.inspectionMissions[task.variables?.missionType?.value || "FIRST_INSPECTION"] =
            `${designatedExpert.personDetails.lastName} ${designatedExpert.personDetails.name}`;

            try {
            const result = await dispatch(updateClaim(task?.businessKey, additionalData));
            console.log('Claim updated successfully:', result);
            } catch (error) {
            console.error('Failed to update claim:', error);
            }

            //create Mission in app Expert
           console.log(" inspectorWorkspaceId ",designatedExpert.inspectorWorkspaceId)
           const mission =  await dispatch(createMissionExpert(claim ,task , designatedExpert.inspectorWorkspaceId , location ));
           if (!mission || !mission._id ||! mission.claim) {
                throw new Error("Mission not created");
            }
           setVariables(variables.claimMissionExpertId = { value: mission?._id, type: "String" });
           setVariables(variables.claimExpertId = { value: mission?.claim?._id, type: "String" });
           setVariables(variables.inspectorWorkspaceId = { value: designatedExpert?.inspectorWorkspaceId, type: "String" });
           setVariables(variables.inspectorEmail = { value: getFirstActiveEmailContact(designatedExpert), type: "String" });
           setVariables(variables.inspectorPhone = { value: getFirstActivePhoneContactForInspector(designatedExpert), type: "String" });
           setVariables(variables.designatedInspectorName = { value: `${designatedExpert.personDetails.lastName} ${designatedExpert.personDetails.name}`, type: "String" });
              // console.log("mission for claimExpertId", mission)
              // console.log("claimExpertId", mission?.claim?._id)
          } catch (error) {
            console.error(error);
            return;
          }
        }
        if (showSections[1]) {
            //console.log("designatedGarage", designatedGarage)
          if (!designatedGarage) {
            alert("Veuillez sélectionner Garage.");
            return;
          } 
            const serviceProposalId = task.variables._proposedServiceId.value;

            const ReparationMission = {
                associatedRepairer: designatedGarage.associatedParty,
                associatedClaimNumber: task.businessKey || "unknown",
                serviceProposal:  serviceProposalId
          }; 
            if(task.variables.managementType.value === "AUTOP" || task.variables.managementType.value === "AfriqueAssistance"){
                ReparationMission.repairerDecision ="ACCEPTANCE" }
          try {
            const response = await dispatch(createReparationMission(ReparationMission));
            setVariables(variables.repartionMissionId = { value: response._id, type: "String" });
            setVariables(variables.designatedRepairer = { value: designatedGarage.organizationName, type: "String" });
            setVariables(variables.idRepairerGroup = { value: designatedGarage?.additionalData?.idRepairerGroup, type: "String" });
            setVariables(variables.repairerEmail = { value: getEmailContactGarage(designatedGarage.associatedParty), type: "String" });
            setVariables(variables.designatedRepairerPartyUid = { value: designatedGarage.associatedParty, type: "String" });
            setVariables(variables.repairerPhone = { value: getFirstActivePhoneContact(designatedGarage), type: "String" });
            // add ReparationMission to list of ReparationMissions in service proposal
              const updatedServiceProposal = { reparationMissions: [response._id] };
              await updateServiceProposal(serviceProposalId, updatedServiceProposal);
          } catch (error) {
            console.error(error);
            return;
          }
        }

        try {
        await dispatch(completeTask(taskId, username, variables));
         navigate('/todo-list', { reload: true });
        } catch (error) {
          console.error(error);
          alert("Erreur lors de la validation. Veuillez réessayer.");
        }
      }

    useEffect(() => {
        fetchTask();
    }, [dispatch, taskId, username]);

 

    useEffect(() => {
        serviceProposal();
    }, [serviceProposalId, task]);

    return (
        <div className={classes.root}>
            <div style={{display: 'flex'}}>
            <div className={classes.mainContent}>
            <TaskInformation taskId={taskId} onClaimStatusChange={setIsTaskClaimed}/>
             
            <Paper className={classes.paper}>
                {sections.map((section, index) => (
                    showSections[index] && (
                    index === 0 && designatedExpert? (
                        <div  className={classes.leftSection} >
                            <ExpertCart
                                filteredInspectors={designatedExpert}
                                performanceKPI={designatedExpert?.performanceKPI}
                                noteExpert={"NAN"}
                                width={'100%'}
                                height={'100%'}
                                restDesignated={() =>isTaskClaimed? null : setDesignatedExpert("")}
                            />
                       </div>
                    ) : index === 1 && designatedGarage? (
                        <div  className={classes.leftSection}>
                            <GarageCart
                                filteredRepairers= {designatedGarage}
                                selectedRepairer={designatedGarage}
                                width={"100%"}
                                height={'100%'}
                                restDesignated={() =>isTaskClaimed? null : setDesignatedGarage("")}
                            />
                        </div>
                    ) : (
                        <div className={classes.leftSection} key={index}>
                        <div className={classes.uploadRectangle} onClick={isTaskClaimed? null : section.onClick}>
                            {section.icon}
                            <div className={classes.uploadTextPrimary}>{section.textPrimary}</div>
                            <div className={classes.uploadTextSecondary}>{section.textSecondary}</div>
                        </div>
                        </div>
                    )
                    )
                ))}
            </Paper>
            </div>
            <PreviewButton claimData={infoSinistre}  />
</div>
            <ValidationButton //taskId={taskId} 
                handleValidation={() =>isTaskClaimed? null : ValidationAction()} />
            <Dialog open={open}
                    onClose={handleClose}
                    classes={{ paper: classes.dialogPaper }}
                    maxWidth={false}
            >
                <DialogTitle className={classes.dialogTitle}>
                    {dialogContent === "Désignation expert" ? <span>Recherche Expert</span>:<span>Recherche Garage</span>}
                    <IoCloseOutline className={classes.closeButton} size={24} onClick={handleClose} />
                </DialogTitle>
                <DialogContent>
                    {dialogContent === "Désignation expert" ?
                        <ExpertSelector filters={expertFilters}  designatedRepairerPartyUid={designatedRepairerPartyUid} designatedExperts={designatedExperts} />
                        :
                        <GarageSelection filters={repairerFilters} designatedGarages={designatedGarages}/>}
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default DesignateParties;
